module.exports = __webpack_public_path__ + "img/ltkhalloween-2x.ab882ea.jpg";